<ng-template #menuBarTitleTemplate>
  <span  class="navbar-brand" [matTooltipShowDelay]="1" [matTooltip]="version"></span>
</ng-template>
<lib-starbase-modal-overlay [zIndex]="203" [glassMode]="glassMode" [darkMode]="darkMode" [overlayEnabled]="overlayEnabled"></lib-starbase-modal-overlay>
<lib-starbase-modal-dialog #mainModalDialog [zIndex]="212" [animate]="true" [glassMode]="glassMode" [darkMode]="darkMode"></lib-starbase-modal-dialog>
<lib-starbase-notification #StarbaseNotificationComponent></lib-starbase-notification>
<lib-starbase-notification-history #notiHistory></lib-starbase-notification-history>

<ng-template #menuBarLinksTemplate>
  <div class="container-fluid d-flex align-items-center justify-content-between w-100 p-2">
    <ul class="navbar-nav mr-auto">
    <li class="nav-item ms-1" [routerLinkActive]="'active'">
      <a class="nav-link" [routerLink]="['/home']" [routerLinkActive]="['activeLink']">
        <i class="fal fa-lg fa-tachometer"></i>
        Dashboard
      </a>
    </li>
    <li *ngIf="appGlobals.site?.reportsActive && (isAdmin() || loggedInUser.hasPermissions('reportread'))" class="nav-item ms-1" [routerLinkActive]="'active'">
      <a class="nav-link" [routerLink]="['/reports']" [routerLinkActive]="['activeLink']">
        <i class="fal fa-lg fa-file-chart-line"></i>
        Reports
      </a>
    </li>
    <li *ngIf="isAdmin() || loggedInUser.hasPermissions('lookupread')" class="nav-item ms-1" [routerLinkActive]="'active'">
      <a class="nav-link" [routerLink]="['/lookup-tables']" [routerLinkActive]="['activeLink']">
        <i class="fal fa-lg fa-brackets-curly"></i>
        Lookup Tables
      </a>
    </li>
    <li *ngIf="isAdmin()" class="nav-item ms-1" [routerLinkActive]="'active'">
      <a class="nav-link" [routerLink]="['/logs']" [routerLinkActive]="['activeLink']">
        <i class="fal fa-lg fa-history"></i>
        Logs
      </a>
    </li>
  </ul>
  <span *ngIf="appGlobals.site" style="font-size: 1em;" class="navbar-brand" [matTooltipShowDelay]="1" [matTooltip]="appGlobals.site.siteCode + ' - ' + appGlobals.site.siteName"><b>{{ appGlobals.oneSiteMode ? appGlobals.site.siteCode : '' }}</b></span>
  </div>
</ng-template>

<ng-template #optionsModal>
  <tabset>
    <tab heading="Site Settings" class="mt-2">
      <h5>
        <i class="fad fa-adjust me-1"></i>
        Appearance
      </h5>
      <div class="btn-group" role="group">
        <label role="button" [ngClass]="{'active': !darkMode && !glassMode}" tabindex="0" (click)="setStyle('normal')" class="btn btn-info">
          <i class="fal fa-sun me-1"></i>
          Normal
        </label>
        <label role="button" [ngClass]="{'active': darkMode}" tabindex="0" (click)="setStyle('dark')" class="btn btn-info">
          <i class="fal fa-moon-stars me-1"></i>
          Dark
        </label>
      </div>
      <hr>
      <h5>
        <i class="fal fa-palette"></i>
        Menu Color
      </h5>
      <color-circle class="colorPicker" [colors]="this.colorPalette" (onChange)="setMenuColor($event)"></color-circle>
      <hr>
      <h5>
        <i class="fal fa-clock"></i>
        Time Zone
      </h5>
      <select name="timeZoneSelect" [(ngModel)]="timezone" class="form-control editable" (change)="setTimeZone($event.target.value)">
        <option *ngFor="let zone of timezones" [value]="zone.standardTimeCode">{{ zone.name }}</option>
      </select>
      <br>

      <h5>
        <i class="fal fa-sunrise"></i>
        Daylight Savings Time Observed?
      </h5>
      <div class="btn-group" role="group">
        <label role="button" [ngClass]="{'active': isDSTObserved}" tabindex="0" (click)="setDSTObserved(true)" class="btn btn-info">
          <i class="fal fa-check me-1"></i>
          Yes
        </label>
        <label role="button" [ngClass]="{'active': !isDSTObserved}" tabindex="0" (click)="setDSTObserved(false)" class="btn btn-info">
          <i class="fal fa-times me-1"></i>
          No
        </label>
      </div>

      <h5 class="mt-2">
        <i class="fal fa-lightbulb"></i>
        Tooltips
      </h5>

      <label for="tooltipDelaySlider">Display Tooltips </label><b style="color:red">BETA</b><br>
      <div class="form-check d-inline-block">
        <input class="form-check-input" type="checkbox"  [(ngModel)]="displayTooltip" style="width: 1.4rem; height: 1.4rem;" (change)="setTooltipDisplay(displayTooltip)">
      </div>

      <hr style="border-color: #111;">
      <h6>
        <button class="btn btn-sm btn-warning" [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear all your preferences stored in this browser." type="button" (click)="clearPrefs()">
          <i class="fal fa-minus-octagon me-1"></i>
          Reset Preferences
        </button>
      </h6>

    </tab>
    <tab heading="User Settings" class="mt-2" style="min-width: 1100px;" [active]="openOnUser">
      <lib-account-management
        [userDashDataService]="this.userSvc"
        [contactDashDataService]="this.contactSvc"
        [isAdmin]="this.isAdmin()"
        accentColor="#1b1b1b"
        [subscriptionBasedApp]="false"
        [passwordScorerFn]="score"
        [darkMode]="this.darkMode"
        [glassMode]="this.glassMode"
        [openOnTab]="currentAccountTab"
        (messageEmitter)="this.sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (requestRecordHistoryEmitter)="handleRecordHistoryRequest($event, true)">
      </lib-account-management>
    </tab>
    <tab heading="Dashboard" class="mt-2">
      <a class="btn btn-sm btn-link me-1" style="border: 1px solid;" [matTooltipShowDelay]="tooltipDelay" matTooltip="(This will close the options dialog)" (click)="openDashboardSettings()">
        <i class="fal fa-tachometer-fastest"></i><i class="fal fa-cog me-1"></i>
        Open Dashboard Customizations
      </a>
    </tab>

    <tab heading="Scale Settings" class="mt-2">
      <lib-scale-settings-modal
        [isAdmin]="isAdmin()"
        [sbSvcProvider]="sbSvcProvider"
        [scaleLinkSvc]="scaleLinkSvc">
      </lib-scale-settings-modal>
    </tab>
  </tabset>
</ng-template>

<ng-template #recordHistoryModal>
  <div *ngIf="recordHistoryLoading" style="width: 360px; height: 180px;"><div class="loader" style="margin: auto; margin-top: 90px;"></div></div>
  <lib-new-table-editor #mainLogs *ngIf="!recordHistoryLoading"
  modelName="Entity record history"
  (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
  [userViewOptions]="recordHistoryViewOpts"
  [darkMode]="appGlobals.getStoredDarkModeSetting()"
  [glassMode]="appGlobals.getStoredGlassModeSetting()"
  [usePagination]="true"
  [loadAllClientside]="false"
  [tableEditable]="false"
  [dataSvc]="logSvc"
  [rppChoices]="[25, 50, 100]"
  [columns]="recordHistoryCols"
  [dataFilterParams]="recordHistoryData">
    <h6 class="Starbase-Title-Font">
      {{ logSvc.lastRetrievedEntityName }}
    </h6>
    <span class="small text-muted">Guid: {{ recordHistoryData?.filters[0][1] }}</span>
    <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="logCols" let-compactMode="compactMode">
      <span style="display: contents;" lib-table-row
      [rowData]="rowData"
      [columnDefinitions]="recordHistoryCols"
      [allowEdit]="false"
      [compactMode]="compactMode">
    </span>
    </ng-template>
  </lib-new-table-editor>
</ng-template>

<ng-template #helpAboutModal>
  <img src="../assets/images/ScaleTech long 2025-11-19 .png" style="z-index: -1; margin: 0 auto; width: auto; max-width: 45em; display: flex; justify-content: center;" >
  <br><br>
  <p>
    <label style="font-size: medium;" (click)="redirectToAttributions()">{{ version }}</label>
  </p>
  <hr>
  <small class="text-muted"><img src="../assets/images/Stellar_JustStar.png" style="display: inline; height: 55px; vertical-align: middle;"> Created by Stellar Programming &amp; Consulting, Inc. &copy; {{ currentYear }} &nbsp; <a href="https://stellarstar.com" target="_blank" rel="noopener noreferrer">StellarStar.com</a></small>
</ng-template>

<lib-starbase-menubar #mainMenu [appName]="title" [appVersion]="version" [appTitleTemplate]="menuBarTitleTemplate" [appLinksTemplate]="menuBarLinksTemplate" [backgroundCss]="menuBarColor" [imageSrc]="appGlobals.site && appGlobals.site.siteLogoPath ? '../' + appGlobals.site.siteLogoPath : '../assets/images/ScaleTech long 2025-11-19 .png'" [appVersion]="version" [displayName]="displayName" [user]="loggedInUser" [darkMode]="darkMode" [glassMode]="glassMode" [showStarbaseTag]="appGlobals.site && appGlobals.site.siteLogoPath" (showHelpEmitter)="helpButtonPressed()" (optionsEmitter)="optionsPressed()" (showNotificationsEmitter)="toggleNotificationHistory()" (logoutEmitter)="logOut()"></lib-starbase-menubar>
<router-outlet></router-outlet>

<div class="dashModule" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" style="position: fixed; top:2.5%; left:0.5%; width:99%; height: auto; max-height: 95%; z-index:204; overflow-y: auto;" [style.min-height]="appGlobals.oneSiteMode ? '' : '75%'" *ngIf="viewSiteEditor" [style.border-color]="this.appGlobals.getMenuColor()">
  <lib-site-editor
    [darkMode]="darkMode"
    [glassMode]="glassMode"
    [tooltipDelay]="tooltipDelay"
    [appGlobals]="appGlobals"
    [sbSvcProvider]="sbSvcProvider"
    [siteSvc]="siteSvc"
    [terms]="terms"
    (openRateSchedule)="openRSModal($event)"
    (recordHistoryEmitter)="handleRecordHistoryRequest($event, true)"
    (siteEditorClose)="closeSiteEditor()">
    <div>
      <h2 class="me-1 text-center" [style.color]="this.appGlobals.getMenuColor()">
        <i class="fal fa-map"></i>
        {{ appGlobals.oneSiteMode ? 'Site' : 'Sites'}}
      </h2>
    </div>
  </lib-site-editor>
</div>

<div class="dashModule" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" style="position: fixed; top:2.5%; left:0.5%; width:99%; min-height: 75%; height: auto; max-height: 95%; overflow-y: scroll; overflow-x: auto; z-index:204; border-color: #600fa3;" *ngIf="viewRateSchedules">
  <lib-rate-schedule
    [darkMode]="darkMode"
    [glassMode]="glassMode"
    [rateScheduleHeader]="rateHeader"
    [accentColor]="'#600fa3'"
    [materialsAndServices]="materialsAndServices"
    [rateSvc]="rateSvc"
    [sbSvcProvider]="sbSvcProvider"
    [appGlobals]="appGlobals"
    (rateScheduleCopyEvent)="launchCopyRateScheduleWizard($event)"
    (rateScheduleClose)="closeRateSchedules()"></lib-rate-schedule>
</div>

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="dashModule wizards" *ngIf="copyRateWizOpen" [style.color]="'#600fa3'" style="width: 80%; height: auto; padding: 0; z-index: 206; color: #600fa3;">
  <lib-copy-rate-wizard #copyWizard *ngIf="copyRateWizOpen"
    [mainColor]="'#600fa3'"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [rateSchedule]="rateHeader"
    [customers]="customers"
    [jobCodes]="jobCodes"
    [jobCategories]="jobCategories"
    [sites]="sites"
    [materialsAndServices]="materialsAndServices"
    [rateSvc]="rateSvc"
    [jobSvc]="jobSvc"
    [customerSvc]="contactSvc"
    [sbSvcProvider]="sbSvcProvider"
    [appGlobals]="appGlobals"
    (wizardCompletedEmitter)="handleCopyRateScheduleWizard($event)"
    (wizardCancelledEmitter)="cancelCopyRateScheduleWizard($event)">
      <i [ngClass]="'fal fa-money-check-alt'" style="font-size: 2rem; color: #600fa3"></i>
      <strong style="color: #600fa3;">Copy Rate Schedule{{ copyWizard.copyRateWizard?.currentStep > 0 ? (copyWizard.toCustomer ? " to Customer" : " to Job") : ""}}</strong>
  </lib-copy-rate-wizard>
</div>
